"use strict";
/**
 * API: Controller Sessió
 * Fitxer: SessAPI
 * Autor: Jordi Riu Amblàs
 * Data: 31/05/2017
 * (c) Ajuntament de Manresa - mai 2017 - Departament de Sistemes d'Informació
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AppApi_1 = require("../../api/AppApi");

var SessApi =
/** @class */
function () {
  function SessApi(appState) {
    this.appState = appState;
    var urlBase = appState.config.urlBaseSessApi || process.env.REACT_APP_URL_API_SESSIO || 'intranetserver/intranet/public/Menus/1.0/api';
    this.req = new AppApi_1.default(this.appState, {
      urlBase: urlBase
    });
    this.reqBD = new AppApi_1.default(this.appState, {
      urlBase: urlBase,
      urlBD: appState.config.bd
    });
  }

  SessApi.prototype.postLogin = function (usuari, password) {
    return this.reqBD.postRequest('MNU_LOGIN', {
      login: usuari.toUpperCase(),
      password: password
    });
  };

  SessApi.prototype.getSessio = function (sescod) {
    return this.reqBD.getRequest('MNU_LOGIN', {
      sescod: sescod
    });
  };

  SessApi.prototype.getClientInfo = function () {
    return this.req.getRequest('MNU_CLIENT/GetInfoClient', {});
  };

  SessApi.prototype.getRecurs = function (recCod) {
    return this.reqBD.getRequest('MNU_RECURS', {
      reccod: recCod
    });
  };

  SessApi.prototype.postPermis = function (logIn, recCod) {
    return this.reqBD.postRequest('MNU_PERMISOS', {
      login: logIn,
      reccod: recCod
    });
  };

  return SessApi;
}();

exports.default = SessApi;